module.exports = __webpack_public_path__ + "static/media/2-vodnye-zabavy.06f6704f.jpg";